import {request} from './http';
import {api} from './api';

//字典查询
export function getDictData(dictType, successCallBack) {
    request(api + "/api/common/getDictData?dictType=" + dictType, "post", {}, successCallBack);
}

//获取一级菜单
export function getMenuFirst(languageNum, successCallBack) {
    request("/api/menu/first?languageNum=" + languageNum, "post", {}, successCallBack);
}

//获取二级菜单
export function getMenuTwo(params, successCallBack) {
    request("/api/menu/two?" + queryParams(params), "post", {}, successCallBack);
}

//banner
export function getBanner(languageNum, successCallBack) {
    request("/api/banner/list?languageNum=" + languageNum, "post", {}, successCallBack);
}

//搜索
export function searchRequest(params, successCallBack) {
    request("/api/banner/search?" + queryParams(params), "post", {}, successCallBack);
}


//oem解决方案
export function getOem(languageNum, successCallBack) {
    request("/api/oem/list?languageNum=" + languageNum, "post", {}, successCallBack);
}

//商品列表
export function getGoods(params, successCallBack) {
    request("/api/goods/list?" + queryParams(params), "post", {}, successCallBack);
}

//新闻列表
export function getInformation(params, successCallBack) {
    request("/api/information/list?" + queryParams(params), "post", {}, successCallBack);
}

//合伙人列表
export function getPartners(params, successCallBack) {
    request("/api/partners/list?" + queryParams(params), "post", {}, successCallBack);
}

//咨询提交
export function consultSubmit(params, successCallBack) {
    // var xhr = new XMLHttpRequest();
    //
    // xhr.open('post', api + "/api/consulting/submit?" + queryParams(params));
    // // xhr.setRequestHeader("Content-type", "application/json");
    //
    // xhr.send();
    // xhr.onreadystatechange = function () {
    //     // 这步为判断服务器是否正确响应
    //     if (xhr.readyState == 4 && xhr.status == 200) {
    //         console.log(xhr.responseText);
    //     }
    // };
    request("/api/consulting/submit?" + queryParams(params), "post", {}, successCallBack, successCallBack);
}

//单页详情
export function singleDetail(params, successCallBack) {
    request("/api/single/detail?" + queryParams(params), "post", {}, successCallBack);
}

//类型列表
// 1下载中心
// 2:常见问题
// 3:关于我们地区
// 4:关于我们事项
export function getTypeList(params, successCallBack) {
    request("/api/rce/typeList?" + queryParams(params), "post", {}, successCallBack);
}

//下载中心列表
export function getDownloadList(params, successCallBack) {
    request("/api/rce/detailList?" + queryParams(params), "post", {}, successCallBack);
}

//品牌列表
export function getCompatibleBrand(params, successCallBack) {
    request("/api/compatible/list?" + queryParams(params), "post", {}, successCallBack);
}

//品牌列表
export function getCompatibleModel(params, successCallBack) {
    request("/api/compatible/modelList?" + queryParams(params), "post", {}, successCallBack);
}

export function getCode(params, successCallBack) {
    request("/api/compatible/modelList?" + queryParams(params), "post", {}, successCallBack);
}


// https://cloud.longsys.com/guard/sn/open/query/code

function queryParams(data = {}) {
    let params = "";
    for (let key in data) {

        if (params.length) {
            params += "&"
        }
        params = params + key + "=" + data[key]
    }
    return params;

}

